import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Eligible = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.4 18.07c0 .18-.15.33-.33.33H3.93c-.18 0-.33-.15-.33-.33v-5.44h5.23c-.1-.47-.15-.95-.15-1.45V11H3.6V9.15c0-.18.15-.33.33-.33h5.16c.2-.57.46-1.11.79-1.6H3.93C2.87 7.22 2 8.09 2 9.15v8.92C2 19.13 2.87 20 3.93 20h14.14c1.06 0 1.93-.87 1.93-1.93v-.95c-.49.34-1.03.62-1.6.83v.12Z" />
      <Path d="M15.9 5.18c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 10.6A4.6 4.6 0 1 1 15.9 6.58a4.6 4.6 0 0 1-.001 9.201Z" />
      <Path d="M15.1 13.54c-.18 0-.36-.07-.5-.21l-1.52-1.52a.706.706 0 0 1 0-.99c.27-.27.72-.27.99 0l1.03 1.03 2.82-2.82c.27-.27.72-.27.99 0s.27.72 0 .99l-3.32 3.32c-.14.14-.32.21-.5.21l.01-.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Eligible
